export default "__VITE_ASSET__t_s_6BJB__"